
import {  Box, TextField } from "@mui/material";
import { useState } from "react";
import HintsAutocomplete, { HintRandomizerDto } from "./HintsAutocomplete";
import OotItemContextMenuButton from "./OotItemContextMenuButton";
import { useGetHintDead } from "./HintHelper";
import { isEmpty, isNil } from "lodash";
import MixPoolPlaceAutocomplete from "../mixpool/MixPoolPlaceAutocomplete";
import { OotItemDto } from "./OotItemAutocomplete";


export const DefaultSometimeHint : SometimeHintProps = {type: "sometimes", label: "Sometimes", defaultState: 0 }
export interface SometimeHintProps {
    type?: "sometimes" | "dual" | "entrance"
    label?: string,
    hint?: HintRandomizerDto |null
    defaultState?: 0 | 1 | 2,
    state?: number,
    setState?: (state: number) => void,
    setHint?: (state: HintRandomizerDto | null) => void
    hintItem1?: OotItemDto | null,
    hintItem2?: OotItemDto | null
    setHintItem?: (i: OotItemDto | null, indexItem: number) => void
}

const SometimeHint = (props: SometimeHintProps) => {

    let [localState, setLocalState] = useState<number>(props.defaultState ?? 0);

    let [localHint, setLocalHint] = useState<HintRandomizerDto | null>(props.hint ?? null)


    let state = isNil(props.setState) ? localState : props.state
    let setState = isNil(props.setState) ? setLocalState : props.setState

    let hint = isNil(props.setHint) || localHint !== props.hint ? localHint : props.hint
    let setHint = isNil(props.setHint) ? setLocalHint : props.setHint

    const handleRightClik = () => {
    
            setState(((state ?? 0) + 1) % 3)
        
    }

    const handleDoubleClick = () => {
        setHint(null)
    }

    let dead = useGetHintDead(hint);

    let forceDual = props.type === "dual"  || state === 1

    let label = props.label ?? (forceDual ? "Dual Hint" : "Sometimes")
    return <Box display="flex" flexBasis={"fit-content"} onDoubleClick={() => handleDoubleClick()}>
        <Box  onContextMenu={(e) => {e.preventDefault(); handleRightClik();}}>
        {isNil(hint) && state !== 2 && <HintsAutocomplete  label={label} type={forceDual ? "dual" : props.type} value={hint} additionalOnChange={setHint} />}
        {(!isNil(hint) || !isNil(props.hint)) && (state !== 2) && <Box 
                                                                    width={"100px"} 
                                                                    sx={{fontSize: "11px"}} 
                                                                    textOverflow={"wrap"} 
                                                                    justifyContent={"center"} 
                                                                    alignContent={"center"}
                                                                    textAlign={"center"} 
                                                                    onContextMenu={(e) => {e.preventDefault(); setHint(null)}} 
                                                                    onClick={(e) => {e.preventDefault(); if(!isNil(props.hint)) setHint(null)}} >
                                                                    {!isNil(hint?.img) ? <img src={hint?.img} width={32} height={32} alt={hint?.name} /> : hint?.quickAlias ?? hint?.name}
                                                                </Box>}
            {state === 2 && <TextField sx={{ minWidth: "150px" }} 
            size="small" label={"Sometimes"} 
            onChange={(e) => { e.preventDefault(); setLocalHint({ name: e.currentTarget.value }); }} 
            onBlur={(e) => {
                if (isNil(localHint) || isEmpty(localHint))
                    setHint(null);
                else
                    setHint(localHint)
            }} 
            value={hint?.name}
            />}
        </Box>
        {/* <Box display="flex" flexDirection={"column"} justifyContent="center" margin={"5px"}> <RightArrow /> </Box> */}
        {props.type !== "entrance" && <OotItemContextMenuButton dead={dead} item={isNil(props.hintItem1) ? undefined : props.hintItem1} onItemChange={(v) => {if(!isNil(props.setHintItem)) props.setHintItem(v, 1)}}/>}
        {props.type !== "entrance" && (forceDual || state === 2) && <OotItemContextMenuButton dead={dead} item={isNil(props.hintItem2) ? undefined : props.hintItem2} onItemChange={(v) => {if(!isNil(props.setHintItem)) props.setHintItem(v, 2)}}/>}
        {props.type === "entrance" && <MixPoolPlaceAutocomplete />}
    </Box>
}

export default SometimeHint;